import { Divider, Menu } from '@mantine/core';
import {
  ExitIcon,
  GearIcon,
  LockClosedIcon,
  PersonIcon,
} from '@modulz/radix-icons';
import { useNavigate } from 'react-router-dom';
import { Box, Flex } from '..';
import { ReactComponent as QuerylizerLogomark } from '../../assets/icons/querylizer-logomark.svg';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { logoutUser } from '../../redux/slices/userSlice';
import { NavbarPropsI } from '../../types/common';
import {
  Avatar,
  AvatarContainer,
  NavbarLogo,
  ProfileContainer,
  Root,
  SettingsIcon,
  UserDetails,
} from './Navbar.styled';

const Navbar = ({ NavbarChildComp }: NavbarPropsI) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const user = useAppSelector((state) => state.userR.user);

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    dispatch(logoutUser());
    navigate('/');
  };

  return (
    <Root>
      <NavbarLogo>
        <QuerylizerLogomark
          height="32px"
          onClick={() => navigate(`/dashboard`)}
        />
      </NavbarLogo>

      <Box style={{ width: '100%' }}>{NavbarChildComp}</Box>

      <UserDetails>
        {user && user.username ? (
          <ProfileContainer>
            <Flex justifyContent="space-between" alignItems="center">
              <AvatarContainer>
                <Avatar />
              </AvatarContainer>
              <Menu
                control={
                  <Box>
                    <SettingsIcon />
                  </Box>
                }
                placement="end"
                transitionDuration={300}
                transitionTimingFunction="ease"
              >
                <Menu.Label>Settings</Menu.Label>
                <Menu.Item
                  icon={<PersonIcon />}
                  disabled
                  rightSection={<LockClosedIcon />}
                >
                  {user?.username}
                </Menu.Item>
                <Menu.Item
                  icon={<GearIcon />}
                  disabled
                  rightSection={<LockClosedIcon />}
                >
                  Settings
                </Menu.Item>
                <Divider />
                <Menu.Item
                  color="red"
                  icon={<ExitIcon />}
                  onClick={handleLogout}
                >
                  Logout
                </Menu.Item>
              </Menu>
            </Flex>
          </ProfileContainer>
        ) : null}
      </UserDetails>
    </Root>
  );
};

export default Navbar;
